// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "apps/static/js/" + {"1007":"AccountConfirmed","2059":"ResetPassword","7917":"EmailSignUp","8677":"Withdraw"}[chunkId] + "." + {"1007":"ae10c942d1805a6fadbf","2059":"6bb534c230c7227d0bc8","7917":"d513ffdf6bd106761aa8","8677":"fc89731735fb3581331a"}[chunkId] + ".js";
};